<template>
  <div class="home">
    <TVBanners />
    <div v-if="!this.quotation.sentToDataBase" class="home__area home__area--forms">
      <div class="home__simulation-form">
        <h2 class="home__simulation-title title">
          <transition enter-active-class="animated bounceInLeft" appear>
            <img
              class="home__simulation-title-arrow"
              :src="require('../assets/img/simulation-arrow.png')"
              alt="Seta para simulação"
            />
          </transition>
          <span class="home__simulation-title-text">
            Simular
            <br />Seguro de Vida
          </span>
          <transition enter-active-class="animated bounceInRight" appear>
            <img
              class="home__simulation-title-arrow"
              :src="require('../assets/img/simulation-arrow-right.png')"
              alt="Seta para simulação"
            />
          </transition>
        </h2>
        <SimulationForm />
        <SimulationResultsShelf title="Qual das opções abaixo mais te agrada?" showResults="All" />
      </div>
    </div>
    <ProtectionsShelf type="list" />
    <InsurersShelf />
  </div>
</template>

<script>
import TVBanners from "../components/banners/TVBanners";
import ProtectionsShelf from "../components/shelves/ProtectionsShelf";
import SimulationForm from "../components/forms/SimulationForm";
import SimulationResultsShelf from "../components/shelves/SimulationResultsShelf";
import QuotationForm from "../components/forms/QuotationForm";
import InsurersShelf from "../components/shelves/MarketingShelf";
import BravarLocation from "../components/locations/BravarLocation";
import successSent from "../assets/svgs/success-sent.svg";

import handleLoadLocalStorage from '../mixins/handleLoadLocalStorage';

import { mapState, mapActions } from "vuex";

export default {
  name: "home",
  components: {
    TVBanners,
    ProtectionsShelf,
    SimulationForm,
    SimulationResultsShelf,
    QuotationForm,
    InsurersShelf,
    BravarLocation
  },
  data() {
    return {
      successSent
    };
  },
  computed: {
    ...mapState(["quotation"])
  },
  mixins: [handleLoadLocalStorage],
};
</script>

<style lang="scss">
.home {
  &__area {
    display: flex;
    padding: $space__st;
    justify-content: center;
    align-items: center;
    box-shadow: $shadow__section;

    @include breakpoint($desk__min--sm) {
      padding: $space__xl;
    }
  }
  &__simulation {
    &-title {
      display: flex;
      justify-content: space-around;
      align-items: center;
      text-transform: uppercase;
      &-arrow {
        width: $space__lg;
        height: 23px;
      }

      &-text {
        font-size: $font-size__lg;
      }
    }
  }
  
}
</style>
